import { render } from "./ExtraContentList.vue?vue&type=template&id=6fe2535c"
import script from "./ExtraContentList.vue?vue&type=script&lang=js"
export * from "./ExtraContentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__